import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { linkRegex } from '../utils';

export default class UserText extends PureComponent {
    static displayName = 'UserText';

    static propTypes = {
        children: PropTypes.string.isRequired,
        className: PropTypes.string,
        element: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    };

    static defaultProps = { element: 'p' };

    // This is a port of utils.linkify using React components instead of strings
    linkConverter(text) {
        const pieces = [];
        if (!text) {
            return pieces;
        }
        let lastIndex = 0;

        const processor = function(capture) {
            const args = Array.prototype.slice.call(arguments);
            args.pop();
            const index = args.pop();
            // No need to push an empty string onto the head of the list if it
            // starts with a link.
            if (index > 0) {
                // Capture the strings between the matches.
                pieces.push(text.substr(lastIndex, index - lastIndex));
            }
            lastIndex = index + capture.length;

            let url = capture;
            const prefix = 'http://';

            // www.example.com -> http://www.example.com
            if (/^(?:www)\./.test(capture)) {
                url = prefix + capture.substr(4);
            }

            // ftp.example.com -> http://ftp.example.com
            if (/^(?:ftp)\./.test(capture)) {
                url = prefix + capture;
            }

            pieces.push(
                <a key={index} href={url} target="_blank">
                    {capture}
                </a>
            );
        };

        // We don't really need the output of this. It's just being used for the
        // side effect of calling processor, which will generate pieces.
        text.replace(linkRegex, processor);
        // No matches were found, so just return the original string.
        if (lastIndex === 0) {
            pieces.push(text);
        }

        return pieces;
    }

    render() {
        const { children, element, ...props } = this.props;
        const convertedChildren = this.linkConverter(children);

        // Clone UserText's props and then just remove children and element.
        // This allows you to do things like:
        //
        // <UserText element="span" className="foo" onClick={this.onClick}>
        //   {user_text}
        // </UserText>
        props.className = (props.className || '') + ' user-text';

        return React.createElement(
            this.props.element,
            props,
            convertedChildren
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/user_text.jsx